<ng-container *ngIf="visible">
    <lg-icon
        *ngIf="_hasColor || _isMixedState"
        class="flag-options option--{{ _getColor() }}"
        [ngClass]="{ clickable: disabled === false }"
        [lgTooltip]="_currentText()"
        [lgTooltipDelay]="0"
        (click)="_showFlagsOptionsPopup($event)"
        [icon]="!_hasColor && _isMixedState ? 'icon-flag-empty' : 'icon-flag-filled'"
    >
    </lg-icon>
    <lg-icon
        *ngIf="!_hasColor && !_isMixedState"
        [ngClass]="{ clickable: disabled === false }"
        (click)="_showFlagsOptionsPopup($event)"
        class="empty-flag"
        icon="icon-flag-empty"
    >
    </lg-icon>
</ng-container>
